module.exports = __webpack_public_path__ + "img/adddeliveryemail.6daf4890.gif";